import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { AccountInfo, GuardianInvite, PersonaInfo } from '@se-po/shared-data-access-models'
import { SeFeToastService } from 'se-fe-toast'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { PersonaGuardianInvite } from 'se-resource-types/lib/CentralService/Households'
import { Persona } from 'se-resource-types/lib/CentralService/Profiles'

@Component({
  selector: 'se-po-household-review',
  templateUrl: './household-review.component.html',
  styleUrls: ['./household-review.component.scss'],
  standalone: false,
})
export class HouseholdReviewComponent implements OnInit {
  @Input() child: PersonaInfo | Persona
  @Input() parent: AccountInfo | Persona
  @Input() guardianInvites: (GuardianInvite | PersonaGuardianInvite)[]
  @Output() public cancelInvite = new EventEmitter<string>()
  @Output() public continue = new EventEmitter<void>()
  @Output() public addAnother = new EventEmitter<void>()
  public loaded = false

  constructor(
    public seFeTranslationsLoader: SeFeTranslationsLoader,
    public translateService: TranslateService,
    public toastService: SeFeToastService,
  ) {}

  public get ready(): boolean {
    return this.loaded && this.guardianInvites && this.child && !!this.parent
  }

  ngOnInit(): void {
    this.loadTranslations()
  }

  async loadTranslations(): Promise<void> {
    await this.seFeTranslationsLoader.load('shared/feature-household-review/assets/translations').then(() => {
      this.loaded = true
    })
  }

  public onCancelInvite(email: string): void {
    this.guardianInvites = this.guardianInvites.filter(invite => {
      const inviteEmail = 'email' in invite ? invite.email : invite.email_address
      return inviteEmail !== email
    })
    this.toastService.info(
      this.translateService.instant('SE_PO_SHARED_FEATURE_HOUSEHOLD_REVIEW.INVITE_REMOVED', { email })
    )
    this.cancelInvite.emit(email)
  }

  public onContinue(): void {
    this.continue.emit()
  }

  public onAddAnother(): void {
    this.addAnother.emit()
  }
}
